export default __webpack_public_path__ + "static/majewska-d9b614f05e0c6be15ac9ff11171c7f26.jpg";